//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppCardCode from '@/@core/components/app-card-code/AppCardCode.vue'

// demos
import DemoTextareaBasic from './demos/DemoTextareaBasic.vue'
import DemoTextareaAutoGrow from './demos/DemoTextareaAutoGrow.vue'
import DemoTextareaVariant from './demos/DemoTextareaVariant.vue'
import DemoTextareaStates from './demos/DemoTextareaStates.vue'
import DemoTextareaBrowserAutocomplete from './demos/DemoTextareaBrowserAutocomplete.vue'
import DemoTextareaClearable from './demos/DemoTextareaClearable.vue'
import DemoTextareaCounter from './demos/DemoTextareaCounter.vue'
import DemoTextareaIcons from './demos/DemoTextareaIcons.vue'
import DemoTextareaRows from './demos/DemoTextareaRows.vue'
import DemoTextareaNoResize from './demos/DemoTextareaNoResize.vue'
import DemoTextareaValidation from './demos/DemoTextareaValidation.vue'
import DemoTextareaValidationOnBlur from './demos/DemoTextareaValidationOnBlur.vue'

// code
import {
  textareaBasic,
  textareaAutoGrow,
  textareaVariant,
  textareaStates,
  textareaBrowserAutocomplete,
  textareaClearable,
  textareaCounter,
  textareaIcons,
  textareaRows,
  textareaNoResize,
  textareaValidation,
  textareaValidationOnBlur,
} from './demos/code'

export default {
  components: {
    AppCardCode,
    DemoTextareaBasic,
    DemoTextareaAutoGrow,
    DemoTextareaVariant,
    DemoTextareaStates,
    DemoTextareaBrowserAutocomplete,
    DemoTextareaClearable,
    DemoTextareaCounter,
    DemoTextareaIcons,
    DemoTextareaRows,
    DemoTextareaNoResize,
    DemoTextareaValidation,
    DemoTextareaValidationOnBlur,
  },
  setup() {
    return {
      codeSnippets: {
        textareaBasic,
        textareaAutoGrow,
        textareaVariant,
        textareaStates,
        textareaBrowserAutocomplete,
        textareaClearable,
        textareaCounter,
        textareaIcons,
        textareaRows,
        textareaNoResize,
        textareaValidation,
        textareaValidationOnBlur,
      },
    }
  },
}
